import { CountryCode } from 'root-constants'

export const COUNTRIES_WITHOUT_PAYPAL: string[] = [
  CountryCode.AFGHANISTAN,
  CountryCode.ALBANIA,
  CountryCode.ALGERIA,
  CountryCode.ANGOLA,
  CountryCode.ARGENTINA,
  CountryCode.AZERBAIJAN,
  CountryCode.BAHRAIN,
  CountryCode.BANGLADESH,
  CountryCode.BELIZE,
  CountryCode.BENIN,
  CountryCode.BOLIVIA,
  CountryCode.BRAZIL,
  CountryCode.BULGARIA,
  CountryCode.BURKINA_FASO,
  CountryCode.BURUNDI,
  CountryCode.CAMBODIA,
  CountryCode.CAMEROON,
  CountryCode.CAYMAN_ISLANDS,
  CountryCode.CENTRAL_AFRICAN_REPUBLIC,
  CountryCode.CHAD,
  CountryCode.CHILE,
  CountryCode.CHINA,
  CountryCode.COLOMBIA,
  CountryCode.COMOROS,
  CountryCode.CONGO,
  CountryCode.CONGO_DRC,
  CountryCode.COSTA_RICA,
  CountryCode.CURACAO,
  CountryCode.CYPRUS,
  CountryCode.CZECH_REPUBLIC,
  CountryCode.DJIBOUTI,
  CountryCode.DOMINICA,
  CountryCode.DOMINICAN_REPUBLIC,
  CountryCode.ECUADOR,
  CountryCode.EGYPT,
  CountryCode.EL_SALVADOR,
  CountryCode.ESTONIA,
  CountryCode.ETHIOPIA,
  CountryCode.FIJI,
  CountryCode.GABON,
  CountryCode.GAMBIA,
  CountryCode.GEORGIA,
  CountryCode.GHANA,
  CountryCode.GUATEMALA,
  CountryCode.GUINEA,
  CountryCode.GUINEA_BISSAU,
  CountryCode.GUYANA,
  CountryCode.HAITI,
  CountryCode.HONDURAS,
  CountryCode.HONG_KONG,
  CountryCode.HUNGARY,
  CountryCode.ICELAND,
  CountryCode.INDIA,
  CountryCode.INDONESIA,
  CountryCode.IRAQ,
  CountryCode.IVORY_COAST,
  CountryCode.JAMAICA,
  CountryCode.JORDAN,
  CountryCode.KAZAKHSTAN,
  CountryCode.KENYA,
  CountryCode.KIRIBATI,
  CountryCode.KOSOVO,
  CountryCode.KUWAIT,
  CountryCode.KYRGYZSTAN,
  CountryCode.LAOS,
  CountryCode.LATVIA,
  CountryCode.LEBANON,
  CountryCode.LESOTHO,
  CountryCode.LIBERIA,
  CountryCode.LIBYA,
  CountryCode.LITHUANIA,
  CountryCode.MADAGASCAR,
  CountryCode.MALAWI,
  CountryCode.MALAYSIA,
  CountryCode.MALDIVES,
  CountryCode.MALI,
  CountryCode.MALTA,
  CountryCode.MARTINIQUE,
  CountryCode.MAURITANIA,
  CountryCode.MAYOTTE,
  CountryCode.MEXICO,
  CountryCode.MOLDOVA,
  CountryCode.MONTENEGRO,
  CountryCode.MOROCCO,
  CountryCode.MYANMAR,
  CountryCode.NAMIBIA,
  CountryCode.NEPAL,
  CountryCode.NICARAGUA,
  CountryCode.NIGER,
  CountryCode.NIGERIA,
  CountryCode.OMAN,
  CountryCode.PAKISTAN,
  CountryCode.PALESTINE,
  CountryCode.PANAMA,
  CountryCode.PAPUA_NEW_GUINEA,
  CountryCode.PARAGUAY,
  CountryCode.PERU,
  CountryCode.PHILIPPINES,
  CountryCode.POLAND,
  CountryCode.PUERTO_RICO,
  CountryCode.ROMANIA,
  CountryCode.RWANDA,
  CountryCode.SAINT_LUCIA,
  CountryCode.SAUDI_ARABIA,
  CountryCode.SENEGAL,
  CountryCode.SERBIA,
  CountryCode.SEYCHELLES,
  CountryCode.SIERRA_LEONE,
  CountryCode.SINGAPORE,
  CountryCode.SOMALIA,
  CountryCode.SOUTH_AFRICA,
  CountryCode.SOUTH_KOREA,
  CountryCode.SOUTH_SUDAN,
  CountryCode.SRI_LANKA,
  CountryCode.SUDAN,
  CountryCode.SWAZILAND,
  CountryCode.SYRIA,
  CountryCode.TAIWAN,
  CountryCode.TAJIKISTAN,
  CountryCode.TANZANIA,
  CountryCode.THAILAND,
  CountryCode.TOGO,
  CountryCode.TONGA,
  CountryCode.TUNISIA,
  CountryCode.TURKEY,
  CountryCode.UGANDA,
  CountryCode.UKRAINE,
  CountryCode.UNITED_ARAB_EMIRATES,
  CountryCode.URUGUAY,
  CountryCode.UZBEKISTAN,
  CountryCode.VENEZUELA,
  CountryCode.VIETNAM,
  CountryCode.YEMEN,
  CountryCode.ZAMBIA,
  CountryCode.ZIMBABWE,
]

export const isPayPalAvailableByCountry = (countryCode: string): boolean =>
  !COUNTRIES_WITHOUT_PAYPAL.includes(countryCode.toLowerCase())
